import { TLDTypes } from "../constants/constantApi";
import { isDev } from "./environment";

const data: Record<string, { scriptName: string; gaScriptUrl: string }> = {
	cz: {
		scriptName: '81484708-796f-445d-9696-ebbbcad4c6ab.js',
		gaScriptUrl: 'track.sjednatpujcku.cz',
	},
	cz_test: {
		scriptName: '',
		gaScriptUrl: '',
	},
	kz: {
		scriptName: '682ce1d7-cb8e-421e-8f4d-898d8f2ab5c7.js',
		gaScriptUrl: 'track.finero.kz',
	},
	kz_kz: {
		scriptName: '682ce1d7-cb8e-421e-8f4d-898d8f2ab5c7.js',
		gaScriptUrl: 'track.finero.kz',
	},
	mx: {
		scriptName: '75a21d79-ef33-451e-a2d7-46d787bc51e8.js',
		gaScriptUrl: 'track.finero.mx',
	},
	mx_2: {
		scriptName: '75a21d79-ef33-451e-a2d7-46d787bc51e8.js',
		gaScriptUrl: 'track.finero.mx',
	},
	ro: {
		scriptName: 'e7afbe72-93d1-47b9-90a6-909f472e7b3f.js',
		gaScriptUrl: 'track.incash.ro',
	},
	za: {
		scriptName: '',
		gaScriptUrl: 'track.twalalend.co.za',
	},
	za_2: {
		scriptName: '',
		gaScriptUrl: 'track.yebofin.co.za',
	},
	local: {
		scriptName: '81484708-796f-445d-9696-ebbbcad4c6ab.js',
		gaScriptUrl: 'track.sjednatpujcku.cz',
	}
};

export const getGoogleScripts = (tld?: TLDTypes): { scriptName: string; gaScriptUrl: string } => {

  if (isDev) {
    console.log('[getGoogleScripts] Called with tld:', tld || 'undefined (will use default: cz)');
  }

  const currentTLD = tld ?? 'cz';
  const baseData = data[currentTLD] || { scriptName: '', gaScriptUrl: '' };

  if (isDev) {
    console.log('[getGoogleScripts] Result:', { tld: currentTLD, baseData });
  }

  return baseData;
}
